<template>
    <basic-container>
      <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>预创建记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        ref="crud"
        v-model="form"
        :permission="permissionList"
        @refresh-change="refreshChange"
        @on-load="onLoad"
        :header-cell-class-name="headerCellClassName"
      >
        <template slot-scope="scope" slot="menu">
          <!-- 微信调用成功 且 未关联：需要人工核实 -->
          <el-button
            v-if="scope.row.wxCallStatus === 1 && scope.row.status === 0"
            type="text"
            size="small"
            @click="openVerify(scope.row)"
          >核实</el-button>
          <!-- 其他状态无需操作 -->
          <span v-else style="color: #999; font-size: 12px;">-</span>
        </template>
      </avue-crud>

      <!-- 核实弹窗 -->
      <el-dialog title="核实预创建记录" :visible.sync="verifyVisible" width="500px">
        <el-alert
          title="请先登录微信商户平台，查询该 outBillNo 是否真的发生了转账"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 20px"
        />
        <el-form :model="verifyForm" label-width="120px">
          <el-form-item label="微信转账单号">
            <el-input v-model="verifyForm.outBillNo" disabled />
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="verifyForm.orderId" disabled />
          </el-form-item>
          <el-form-item label="金额">
            <el-input v-model="verifyForm.amount" disabled />
          </el-form-item>
          <el-form-item label="微信侧是否有转账" required>
            <el-radio-group v-model="verifyForm.result">
              <el-radio :label="1">有转账（补录提现记录）</el-radio>
              <el-radio :label="0">无转账（无需处理）</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="verifyForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入核实备注"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="verifyVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitVerify" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </template>

  <script>
  import { mapGetters } from "vuex";
  import { getPrecreateList, verifyPrecreate } from "@/api/healthmanagement/deviceManage";

  const statusDic = [
    { label: "预创建", value: 0 },
    { label: "已关联", value: 1 },
    { label: "已核实", value: 2 },
    { label: "已清理", value: 3 }
  ];

  const wxCallStatusDic = [
    { label: "未调用", value: null },
    { label: "调用成功", value: 1 },
    { label: "调用失败", value: 2 }
  ];

  export default {
    data() {
      return {
        form: {},
        data: [],
        page: { pageSize: 10, currentPage: 1, total: 0 },
        headerCellClassName: "headerClass",
        submitting: false,

        // 核实弹窗
        verifyVisible: false,
        verifyForm: {
          outBillNo: "",
          orderId: "",
          amount: 0,
          result: 1,
          remark: ""
        },

        option: {
          tip: false,
          border: true,
          index: true,
          indexLabel: "序号",
          addBtn: false,
          editBtn: false,
          viewBtn: false,
          delBtn: false,
          selection: false,
          menuWidth: 100,
          searchMenuSpan: 5,
          column: [
            { label: "微信转账单号", prop: "outBillNo", search: true, overHidden: true },
            { label: "订单ID", prop: "orderId", search: true, overHidden: true },
            { label: "金额", prop: "amount" },
            { label: "关联状态", prop: "status", type: "select", dicData: statusDic },
            { label: "微信调用结果", prop: "wxCallStatus", type: "select", dicData: wxCallStatusDic },
            { label: "错误信息", prop: "wxErrorMsg", overHidden: true },
            {
              label: "是否告警",
              prop: "alerted",
              formatter: row => row.alerted === 1 ? "是" : "否"
            },
            { label: "创建时间", prop: "createTime" }
          ]
        }
      };
    },

    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return { addBtn: false, viewBtn: false, delBtn: false, editBtn: false };
      }
    },

    methods: {
      onLoad(page, params = {}) {
        getPrecreateList(page.currentPage, page.pageSize, params).then(res => {
          const data = res.data;
          this.page.total = data.total;
          this.data = data.records || [];
        });
      },

      refreshChange(data) {
        this.onLoad(this.page, data.searchForm);
      },

      /**
       * 打开核实弹窗
       */
      openVerify(row) {
        this.verifyForm = {
          outBillNo: row.outBillNo,
          orderId: row.orderId,
          amount: row.amount,
          result: 1,
          remark: ""
        };
        this.verifyVisible = true;
      },

      /**
       * 提交核实
       */
      submitVerify() {
        this.submitting = true;
        verifyPrecreate({
          outBillNo: this.verifyForm.outBillNo,
          result: this.verifyForm.result,
          remark: this.verifyForm.remark
        })
          .then(res => {
            this.submitting = false;
            if (res.success !== false) {
              this.$message.success("操作成功");
              this.verifyVisible = false;
              this.onLoad(this.page);
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      }
    }
  };
  </script>

  <style scoped>
  .headerClass {
    background-color: #409eff !important;
    color: #fff !important;
  }
  </style>
